/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {getRoutePageComponent, getContextRoutePageComponent} from '../common/controller/route-page-component-registry';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {ExternalAdUnitCopyModalComponent} from './external-ad-unit-copy-modal.component';
import {configureAdminResourceStates} from '../common/controller/admin-resource-routing';
import {ExternalAdUnitResource} from '../../components/api/resources/resource/externaladunit.resource';


export function externalAdUnitStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterHelper('external-ad-units.external-ad-unit', ExternalAdUnitResource, 'app.inv', 'app');
    
        $stateProvider.state(rh.listPath(), rh.list({
          views: {
            'content@app': { component: getRoutePageComponent('external-ad-unit-route') }
          }
        }));
    
        // Same pattern as political-entity / blocklist: edit + analysis are mounted
        // directly in UI-Router views so modelComms reaches them.
        configureAdminResourceStates($stateProvider, rh, {
          objectType: 'ExternalAdUnit',
          editTag: 'adn-external-ad-unit-edit-page',
          twoPanel: {
            rightTag: 'adn-external-ad-unit-analysis-page'
          },
          itemResolve: {
            copyConfig: function() {
              return {
                modalComponent: ExternalAdUnitCopyModalComponent,
                stateUrl: 'app.inv.external-ad-units.external-ad-unit',
                lcase: 'ad unit',
                ucase: 'Ad Unit'
              };
            }
          }
        });
  }, adnRouterHelper);
}
